import React from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardFooter from "components/Card/CardFooter.js";

import avatar from "assets/img/faces/avatar.jpg";

import styles from "assets/jss/material-dashboard-pro-react/views/lockScreenPageStyle.js";

const useStyles = makeStyles(styles);

const GRAPHQL_URL = (process.env.REACT_APP_API_URL || "http://localhost:5001") + "/graphql";

const LOGIN = `
  mutation Login($data: LoginUserDto!) {
    login(data: $data) {
      token
      user { id email name departments { name code } }
    }
  }
`;

export default function LockScreenPage() {
  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  const userName = currentUser?.name || "User";

  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const history = useHistory();
  const classes = useStyles();

  React.useEffect(() => {
    const id = setTimeout(() => setCardAnimation(""), 700);
    return () => window.clearTimeout(id);
  }, []);

  const handleUnlock = async (e) => {
    e.preventDefault();
    if (!password) return;

    setError("");
    setLoading(true);
    try {
      const res = await fetch(GRAPHQL_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          query: LOGIN,
          variables: { data: { email: currentUser?.email || "", password } },
        }),
      });
      const { data, errors } = await res.json();

      if (errors || !data?.login?.token) {
        setError("Incorrect password. Please try again.");
      } else {
        localStorage.setItem("token", data.login.token);
        localStorage.setItem("user", JSON.stringify(data.login.user));
        history.push("/admin/dashboard");
      }
    } catch {
      setError("Cannot connect to server.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.container}>
      <form onSubmit={handleUnlock}>
        <Card
          profile
          className={classes.customCardClass + " " + classes[cardAnimaton]}
        >
          <CardAvatar profile className={classes.cardAvatar}>
            <a href="#pablo" onClick={(e) => e.preventDefault()}>
              <img src={avatar} alt="..." />
            </a>
          </CardAvatar>
          <CardBody profile>
            <h4 className={classes.cardTitle}>{userName}</h4>
            <CustomInput
              labelText="Enter Password"
              id="lock-password"
              error={!!error}
              formControlProps={{ fullWidth: true }}
              inputProps={{
                type: "password",
                autoComplete: "current-password",
                value: password,
                onChange: (e) => { setPassword(e.target.value); setError(""); },
              }}
            />
            {error && (
              <p style={{ color: "#f44336", fontSize: "0.8rem", marginTop: 4 }}>
                {error}
              </p>
            )}
          </CardBody>
          <CardFooter className={classes.justifyContentCenter}>
            <Button color="rose" round type="submit" disabled={loading}>
              {loading ? "Unlocking..." : "Unlock"}
            </Button>
          </CardFooter>
        </Card>
      </form>
    </div>
  );
}
